<template>
<body class="qaBody">
    <header class="header width_total_100 animateContent qaAnimate1">
        <div class="w_container">
            <div class="commonTop">
                <OmpLink></OmpLink>
            </div>
            <div class="bannerPart">
                <div>
                    <div>一键快速生成图表</div>
                    <p>打造您的专属炫酷页面</p>
                </div>
                <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
            </div>
        </div>
    </header>
    <div class="width_total_100 proBottomBg">
        <div class="qa">
            <div class="tree">
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">01</div>
                    <div class="title">
                        TBB的数据安全性如何，企业的数据是否会泄露？
                    </div>
                    <div class="answer">
                        比一般企业级服务器的安全系数更高，有专业IT和专业的DBA进行管理
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">02</div>
                    <div class="title">
                        Tip Biu BI软件运行要求？
                    </div>
                    <div class="answer">
                        运行环境 .NET Core Runtime/SDK 2.2及以上<br/>
                        浏览器 Google Chrome 5.0 版本以上
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">03</div>
                    <div class="title">
                        是否一定要安装在ERP服务器上？
                    </div>
                    <div class="answer">
                        只需安装在可以访问ERP应用服务器和ERP数据库服务器的任意PC上即可，但要求24小时常开，以便定时任务运行
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">04</div>
                    <div class="title">
                        同步器点击了同步数据，但云端不出现怎么办？
                    </div>
                    <div class="answer">
                        1. 确保ERP端有相应月份的指标，同步最近3期或者2021.2-2021.4的指标需确保相应指标在ERP有值<br/>
                        2. 确保连接信息正确，如E10的Restful接口已打开<br/>
                        3. 指标从ERP同步至TBB，可能会有5分钟左右的延迟，可稍等片刻再查看下云端信息<br/>
                        4. 联系客服专员
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">05</div>
                    <div class="title">
                       TBB支持和哪些数据源对接？
                    </div>
                    <div class="answer">
                        营运监控平台支持对接 ERP指标树模块，（不支持明细指标）（不支持明细数据下钻）<br/>
                        数据分析平台支持对接 ERP大部分报表和SQLSERVER数据源（支持明细数据下钻）
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">06</div>
                    <div class="title">
                        TBB是否有用户限制？如何限制？
                    </div>
                    <div class="answer">
                        TBB为注册用户制（E10，易飞等为并发用户制），几个账号就可以登录几名用户，如同时登录同一个账号，另外一处会被强制登出（目前只要购买即赠送5U，鼎捷顾问账户不占U数）
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">07</div>
                    <div class="title">
                        图表数据更新数据的频度如何？
                    </div>
                    <div class="answer">
                        1. 目前支持以  秒、分、时、天、周等频率进行数据同步<br/>
                        2. 考虑到数据量与客户服务器性能，建议不要设置比每小时一次更快的同步频率<br/>
                        3. 要考虑ERP数据来源的生成频率，例如：ERP指标树模块的生成频率是每天一次，那TBB同步时间也为每天一次较为适合（生成为每天0点的话，同步建议设置每天1点，留出ERP生成数据的缓冲时间）
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">08</div>
                    <div class="title">
                        Tip Biu BI有哪些呈现方式？
                    </div>
                    <div class="answer">
                        PC端或者移动端均可
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">09</div>
                    <div class="title">
                        为什么我配置好的图表,别的用户查看这份图表的时候会显示”无权限查看”？
                    </div>
                    <div class="answer">
                        没有批量发布工作表生成数据权限
                    </div>
                </div>
            </div>
        </div>
        <div class="w_container">
            <Footer></Footer>
        </div>
    </div>

    <Control></Control>
    <FreeTry :visible.sync="freeTryVisible"></FreeTry>
</body>
</template>
<script>
import OmpLink from "@/components/common/OmpLink.vue"
import Control from "@/components/common/Control.vue"
import Footer from "@/components/common/Footer.vue"
import FreeTryButton from "@/components/common/FreeTryButton.vue"
import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink, Control,Footer, FreeTryButton, FreeTry
    },
    name: 'Qa',
    data() {
      return {
        freeTryVisible: false
      }
    },
    mounted() {
        this.FAQTopAnimate() // 顶部动画
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Qa',
            contentName : '',
            extend2: 'CN',
        })
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    methods: {
        FAQTopAnimate() {
            var qaAnimate_show1=1;
            $(".qaBody").children(".animateContent").each(function() {
                if($(this).hasClass("qaAnimate1") &&  parseInt(qaAnimate_show1)){
                    qaAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                }
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        }
    }
  }
</script>
<style scoped>
    .header{
        height: 960px;
        background: url(../assets/img/quesH.png) no-repeat center top;
    }
    .header .slog{
        font-size: 44px;
        color: white;
        font-weight: 100;
    }
    .qa{
        margin: -560px auto 0;
        padding: 90px 67px 120px;
        width: 890px;
        background: #fff;
    }
    .tree{
        height: 1050px;
        border-left: #bcc8cf 1px solid;
    }
    .tree .warp{
        position: relative;
        height: 130px;
        width: 100%;
        text-align: left;
    }
    .warp .square {
        position: absolute;
        top: 0px;
        left: -9px;
        z-index: 3;
        width: 17px;
        height: 17px;
        background: #0099E6;
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    .warp .line{
        position: absolute;
        top: 8px;
        left: 0px;
        z-index: 2;
        width: 50px;
        height: 1px;
        background:#bcc8cf;
    }
    .warp .mun{
        position: absolute;
        top: -16px;
        left: 26px;
        color:#001926;
        font-size: 18px;
        font-weight: bold;
    }
    .warp .title{
        position: absolute;
        top: -16px;
        left: 65px;
        font-size: 24px;
        color: #003B59;
    }
    .warp .answer{
        position: absolute;
        top: 24px;
        left: 65px;
        font-size: 14px;
        color: #001926;
        text-align: left;
    }
    .bannerPart p {
        margin-bottom: 30px;
    }
    
    .qa{
        width: 1024px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Qa.vue